import React from 'react';
import PropTypes from 'prop-types';

import formikPropTypes from '@zr/components/Fields/Formik/formikPropTypes';

import ExperienceFields from './ExperienceFields';

const getLegendText = (entryIndex, totalEntries) => (
  `Work Experience (Entry ${entryIndex} of ${totalEntries})`
);

export function IncompleteExperienceFieldset({
  disabled, entryIndex, formikProps, totalEntries, enableRichText,
}) {
  return (
    <fieldset disabled={disabled}>
      <legend className="title">{getLegendText(entryIndex, totalEntries)}</legend>
      <ExperienceFields formikProps={formikProps} enableRichText={enableRichText} />
    </fieldset>
  );
}

IncompleteExperienceFieldset.propTypes = {
  entryIndex: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  formikProps: formikPropTypes.isRequired,
  totalEntries: PropTypes.number.isRequired,
  enableRichText: PropTypes.bool,
};

IncompleteExperienceFieldset.defaultProps = {
  disabled: false,
  enableRichText: false,
};

export default IncompleteExperienceFieldset;
